module.exports = __webpack_public_path__ + "static/media/LogicWedge6_1_continue_2.c6d6f24e.png";